
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ExternalMainNavMenuComponent } from './external-main-nav-menu/external-main-nav-menu.component';
import { ExternalProfileNavMenuComponent } from './external-profile-nav-menu/external-profile-nav-menu.component';
import { SecondNavMenuComponent } from '../second-nav-menu/second-nav-menu.component';

@Component({
    selector: 'app-external-nav-menu',
    imports: [
    RouterModule,
    ExternalMainNavMenuComponent,
    ExternalProfileNavMenuComponent,
    SecondNavMenuComponent
],
    templateUrl: './external-nav-menu.component.html',
    styleUrl: './external-nav-menu.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExternalNavMenuComponent {

}
